<div>
  <ngx-colors ngx-colors-trigger
              style="display: inline-block; margin:5px;"
              [format]="props['format'] || 'hex'"
              [formControl]="formControl"></ngx-colors>
</div>